import { Component, Input, OnInit } from '@angular/core';
import { Organization } from 'src/app/@core/models/infrastructure/Organization.model';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';

@Component({
  selector: 'app-org-urls-step',
  templateUrl: './org-urls-step.component.html',
  styleUrls: ['./org-urls-step.component.scss']
})
export class OrgUrlsStepComponent implements OnInit {

  @Input() organization: Organization;

  constructor(public darkModeService: DarkModeService) { }

  ngOnInit(): void {
  }

  goToUrl(url){
    window.open(url);
  }
}
